/* eslint-disable */
import { FormContextType, RJSFSchema, StrictRJSFSchema, TemplatesType } from '@rjsf/utils';

import { ArrayFieldTemplate, ArrayFieldItemTemplate } from './ArrayFieldTemplate';
import { DescriptionFieldTemplate } from './DescriptionFieldTemplate';
import { ErrorListTemplate } from './ErrorListTemplate';
import { FieldErrorTemplate } from './FieldErrorTemplate';
import { FieldTemplate } from './FieldTemplate';
import { ObjectFieldTemplate } from './ObjectFieldTemplate';
import { TitleFieldTemplate } from './TitleFieldTemplate';
import { WrapIfAdditionalTemplate } from './WrapIfAdditionalTemplate';
import { ButtonTemplates } from './ButtonTemplates';

export function generateTemplates<
	T = any,
	S extends StrictRJSFSchema = RJSFSchema,
	F extends FormContextType = any
>(): Partial<TemplatesType<T, S, F>> {
	return {
		ArrayFieldItemTemplate,
		ArrayFieldTemplate,
		// @ts-ignore
		ButtonTemplates,
		DescriptionFieldTemplate,
		ErrorListTemplate,
		// @ts-ignore
		FieldErrorTemplate,
		FieldTemplate,
		ObjectFieldTemplate,
		TitleFieldTemplate,
		// @ts-ignore
		WrapIfAdditionalTemplate,
	};
}

export default generateTemplates();
